import {FormInputElement} from "./formInputElement";
import type {PropertyValues, TemplateResult} from "lit";
import {html} from "lit";
import Styles from "./formCheckbox.lit.scss";
import {customElement, property, query} from "lit/decorators.js";
import {Dictionary} from "../../../page/elements/dictionary";
import {CHECKBOX_EVENT, type CheckboxEvent} from "../../../page/elements/input/inputEvents";
import type {EopCheckbox} from "../../../page/elements/input/checkbox";
import type {Nullable} from "../../../bootstrap/common/types";

@customElement("eop-form-checkbox")
export class EopFormCheckbox extends FormInputElement<boolean> {

    public static readonly styles = Styles;

    @property({attribute: "label"})
    private label: string;
    @property({attribute: "top-label"})
    private topLabel: string;
    @property({attribute: "label-check"})
    private labelCheck: string;
    @property({attribute: "label-uncheck"})
    private labelUncheck: string;
    @property({attribute: "preselected", type: Boolean})
    private preselected: boolean;
    @query("eop-checkbox")
    private input: EopCheckbox;

    private dictionary: Dictionary;

    public constructor() {
        super(false);
    }

    public connectedCallback(): void {
        this.dictionary = Dictionary.of(this);
        super.connectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="input-element ${this.basicClassMap()}">
                ${this.renderTopLabel()}
                <eop-checkbox
                        input-id=${(this.getFullId())}
                        label=${this.label}
                        ?checked=${this.value}
                        ?required=${this.required}
                        ?invalid=${this.isInErrorState()}
                        ?valid=${this.isInValidState()}
                        ?warning=${this.isInWarningState()}>
                </eop-checkbox>
                ${this.renderValidationIcon()}
            </div>
            ${this.renderValidationMessages()}
        `;
    }

    private renderTopLabel(): Nullable<TemplateResult> {
        if (this.topLabel) {
            return html`
                <div class="label">
                    <span class="label-text">${this.topLabel}</span>
                </div>
            `;
        }
        return null;
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        this.addEventListener(CHECKBOX_EVENT, (e: Event) => this.toggle(e));
    }

    private toggle(event: Event): void {
        const nativeEvent = event as CheckboxEvent<boolean>;
        this.updateValue(nativeEvent.detail.inputValue);
    }

    protected preset(): boolean {
        return this.preselected;
    }

    protected valueEnhancements(inputValue: boolean): Map<string, string> {
        const map = new Map();
        const label = inputValue
            ? this.labelCheck
            : this.labelUncheck;
        map.set("label", label ?? this.dictionary.translate("MSG_CHECKED", inputValue.toString()) + ": " + this.label);
        return map;
    }

    public focusInput(): void {
        this.input.focus();
    }
}